import {
  AppBar,
  Dialog,
  DialogContent,
  IconButton,
  Tab,
  Tabs,
} from '@material-ui/core'
import InnrHead from 'containers/InnrHead'
import React, { useEffect, useState } from 'react'
import { Translate } from 'react-localize-redux'
import CloseIcon from '@material-ui/icons/Close'
import TabPanel from 'components/material/TabPanel'
import EventIcon from '@material-ui/icons/Event'
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import CircularSpinner from 'components/loader/CircularSpinner'
import moment from 'moment'
import PropTypes from 'prop-types'
import useTeamFeature from 'hooks/useTeamFeature'
import useFeatureAccessGuard from 'hooks/useFeatureAccessGuard'
import { createTaskGroup, updateTaskGroup } from 'api/taskGroups/api'
import { formatDateForServer } from '../../utils/formatDate'
import AddEditTrainingTaskGroup from './AddEditTrainingTaskGroup'
import AddEditMatchTaskGroup from './AddEditMatchTaskGroup'
import AddEditGeneralTaskGroup from './AddEditGeneralTaskGroup'
import { TRAININGS_GAME } from 'constants/calender'
import { PLAYER, PLAYER_CAMEL_CASE } from 'constants/player'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const AddTaskGroupDialog = ({
  onClose,
  onSuccess,
  open,
  team,
  selectedTaskGroup,
  dateFormat,
  players,
  isTrainingEvent,
  isMatchEvent,
  eventId,
}) => {
  const [activeTabName, setActiveTabName] = useState(TRAININGS_GAME.training)
  const [isLoading, setLoading] = useState(false)
  const { enabled: hasAddTaskQuestionsEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.task_questions_enabled
  )
  const featureGuard = useFeatureAccessGuard()

  const splitType = (value) => {
    let type = ''
    if (value?.includes(TRAININGS_GAME.training_camel_case)) {
      type = TRAININGS_GAME.training
    } else if (value?.includes(TRAININGS_GAME.match_camel_case)) {
      type = TRAININGS_GAME.match
    } else if (value?.includes(PLAYER_CAMEL_CASE)) {
      type = PLAYER
    } else {
      type = TRAININGS_GAME.general
    }

    return type
  }
  // Form state is uuid-based and maps to the v2 `model_uuids` / `event_uuids`
  // body keys on submit.
  const [taskGroup, setTaskGroup] = useState({
    uuid: selectedTaskGroup?.uuid || null,
    title: selectedTaskGroup?.title || '',
    modelUuids: selectedTaskGroup?.person_uuids || [],
    modelType: selectedTaskGroup
      ? splitType(selectedTaskGroup?.person_type)
      : PLAYER,
    eventType: selectedTaskGroup
      ? splitType(selectedTaskGroup?.event_type)
      : TRAININGS_GAME.training,
    eventUuids: (selectedTaskGroup?.relationships?.events || []).map(
      (event) => event.uuid
    ),
    description: selectedTaskGroup?.description || '',
    dueDateOffset: selectedTaskGroup?.due_date_offset || 0,
    events: selectedTaskGroup?.relationships?.events,
    isEditable: selectedTaskGroup
      ? selectedTaskGroup?.can?.includes('update')
      : true,
    createdAt: selectedTaskGroup?.created_at || null,
    startData: selectedTaskGroup?.start_date || null,
    endData: selectedTaskGroup?.end_date || null,
  })

  const [questions, setQuestions] = useState(
    selectedTaskGroup && selectedTaskGroup.relationships?.questions
      ? selectedTaskGroup.relationships.questions.map(
          ({ uuid, type: questionType, question }) => ({
            uuid,
            questionType,
            question,
          })
        )
      : []
  )
  const [playersList, setPlayersList] = useState()

  const [selectAllPlayers, setSelectAllPlayers] = useState(
    selectedTaskGroup
      ? taskGroup?.modelUuids?.length === playersList?.length
      : true
  )
  const [taskSeries, setTaskSeries] = useState({
    isTaskSeries: selectedTaskGroup?.start_date || false,
    start_date: selectedTaskGroup?.start_date || new Date(),
    end_date: selectedTaskGroup?.end_date || new Date(),
    day_of_week: selectedTaskGroup?.day_of_week || 1,
  })

  const handleTaskSeriesCheckBox = (event) => {
    const today = moment()
    const endDate = moment(today).add('days', 7)

    setTaskSeries({
      ...taskSeries,
      isTaskSeries: event.target.checked,
      start_date: today,
      end_date: endDate,
    })
  }
  const handleCheckboxSelectAllPlayers = (event) => {
    const { checked } = event.target
    setSelectAllPlayers(checked)
    if (checked) {
      setTaskGroup({
        ...taskGroup,
        modelUuids: [...new Set(playersList?.map((p) => p.uuid))],
        [`error_modelUuids`]: playersList?.length <= 0,
      })
    }
  }

  const handleTabChange = (event, newValue) => {
    setActiveTabName(newValue)
    setTaskGroup({
      ...taskGroup,
      eventUuids: [],
    })
  }
  const handleInput = (event) => {
    const {
      target: { name, value },
    } = { ...event }

    setTaskGroup({
      ...taskGroup,
      [name]: value,
      [`error_${name}`]: value === '' || value === null || value === undefined,
    })
  }
  const handlePlayerChange = (modelUuids) => {
    setTaskGroup({
      ...taskGroup,
      modelUuids: [...new Set(modelUuids.map((p) => p.uuid))],
      [`error_modelUuids`]: modelUuids.length <= 0,
    })
  }
  const handleEventChange = (value) => {
    setTaskGroup({
      ...taskGroup,
      eventUuids: [...new Set(value.map((p) => p.uuid))],
      [`error_eventUuids`]: value.length <= 0,
    })
  }

  const validationCheck = () => {
    if (
      taskGroup.title === '' ||
      taskGroup.error_title ||
      taskGroup.modelUuids.length <= 0 ||
      taskGroup.error_modelUuids ||
      taskGroup.eventUuids === '' ||
      taskGroup.error_eventUuids
    ) {
      setTaskGroup({
        ...taskGroup,
        error_title: taskGroup.title === '',
        error_modelUuids: taskGroup.modelUuids.length <= 0,
        error_eventUuids: taskGroup.eventUuids === 0,
      })

      return false
    }
    if (questions.length > 0) {
      const temp = questions.filter(
        (e) => e.questionType == null || e.question == null || e.question === ''
      )
      if (temp.length > 0) {
        setTaskGroup({
          ...taskGroup,
          error_questions: true,
        })

        return false
      }
    }

    return true
  }
  const handleCreate = (eventType) => {
    if (!validationCheck()) {
      return
    }

    const { title, modelUuids, modelType, eventUuids, description, dueDateOffset } =
      taskGroup

    const updatedEventUuids = eventUuids.length ? eventUuids : [eventId]

    const body = {
      title,
      model_uuids: modelUuids,
      model_type: modelType,
      event_uuids: updatedEventUuids,
      event_type: eventType,
      description,
      due_date_offset: dueDateOffset,
    }

    const tempQues = questions
      .filter((e) => e.questionType != null && e.question != null)
      .map(({ questionType, question }) => ({
        question_type: questionType,
        question,
      }))

    if (tempQues.length > 0) {
      body.questions = tempQues
    }

    if (
      taskSeries.isTaskSeries &&
      taskSeries.start_date &&
      taskSeries.end_date
    ) {
      body.start_date = formatDateForServer(taskSeries.start_date)
      body.end_date = formatDateForServer(taskSeries.end_date)
      body.day_of_week = taskSeries.day_of_week
    }

    setLoading(true)
    createTaskGroup(team.uuid, body)
      .then(() => {
        onSuccess()
        onClose()
      })
      .catch((error) => {
        console.error('Error creating task group:', error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleUpdate = (eventType, taskGroupUuid) => {
    if (!validationCheck()) {
      return
    }
    const { title, modelUuids, modelType, eventUuids, description, dueDateOffset } =
      {
        ...taskGroup,
      }
    const body = {
      title,
      model_uuids: modelUuids,
      model_type: modelType,
      event_uuids: eventUuids,
      event_type: eventType,
      description,
      due_date_offset: dueDateOffset,
    }
    const tempQues = questions
      .filter((e) => e.questionType != null && e.question != null)
      .map(({ uuid, questionType, question }) => {
        if (!uuid) {
          return {
            question_type: questionType,
            question,
          }
        }

        return {
          uuid,
          question_type: questionType,
          question,
        }
      })
    if (tempQues.length > 0) {
      body.questions = tempQues
    }
    setLoading(true)
    updateTaskGroup(taskGroupUuid, body)
      .then(() => {
        onSuccess()
        onClose()
      })
      .catch((error) => {
        console.error('Error updating task group:', error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const addNewQuestion = () => {
    if (featureGuard(hasAddTaskQuestionsEnabled)) return

    setQuestions([
      ...questions,
      { uuid: null, questionType: null, question: '' },
    ])
  }
  const handleQuestion = (event, index) => {
    if (featureGuard(hasAddTaskQuestionsEnabled)) return

    const {
      target: { name, value },
    } = { ...event }

    setQuestions((u) =>
      u.map((element, i) => {
        if (index === i) {
          return { ...element, [name]: value }
        }

        return element
      })
    )
  }

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    }
  }
  useEffect(() => {
    const tempPlayers = players.length > 0 ? players : []
    setPlayersList(
      tempPlayers
        .filter((player) => player.first_name)
        .map((player) => ({
          id: player.uuid,
          uuid: player.uuid,
          label: `@${player.first_name} ${
            player.last_name ? player.last_name : ''
          }`,
        }))
    )
    if (!selectedTaskGroup) {
      setTaskGroup({
        ...taskGroup,
        modelUuids: [...new Set(tempPlayers.map((p) => p.uuid))],
        [`error_modelUuids`]: tempPlayers.length <= 0,
      })
    }
  }, [players])
  useEffect(() => {
    if (isMatchEvent || taskGroup?.eventType === TRAININGS_GAME.match) {
      setActiveTabName(TRAININGS_GAME.match)
    } else if (
      isTrainingEvent ||
      taskGroup?.eventType === TRAININGS_GAME.training
    ) {
      setActiveTabName(TRAININGS_GAME.training)
    } else {
      setActiveTabName(TRAININGS_GAME.general)
    }
  }, [])

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth
      maxWidth="sm"
      PaperProps={{ elevation: 0 }}
    >
      {isLoading && <CircularSpinner />}
      <InnrHead title={<Translate id="task-management.add-task" />}>
        {' '}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </InnrHead>
      <DialogContent>
        <AppBar position="static" color="transparent" elevation={0}>
          <Tabs
            value={activeTabName}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab
              icon={<EventIcon color="action" />}
              label={<Translate id="menu.training" />}
              {...a11yProps(TRAININGS_GAME.training)}
              style={{
                display:
                  (selectedTaskGroup &&
                    taskGroup.eventType !== TRAININGS_GAME.training) ||
                  isMatchEvent
                    ? 'none'
                    : 'block',
              }}
              value={TRAININGS_GAME.training}
            />
            <Tab
              icon={<EmojiEventsIcon color="action" />}
              label={<Translate id="button.match" />}
              {...a11yProps(TRAININGS_GAME.match)}
              style={{
                display:
                  (selectedTaskGroup &&
                    taskGroup.eventType !== TRAININGS_GAME.match) ||
                  isTrainingEvent
                    ? 'none'
                    : 'block',
              }}
              value={TRAININGS_GAME.match}
            />
            <Tab
              icon={<EventIcon color="action" />}
              label={<Translate id="task-management.general-task" />}
              {...a11yProps(TRAININGS_GAME.general)}
              style={{
                display:
                  (selectedTaskGroup &&
                    taskGroup.eventType === TRAININGS_GAME.training) ||
                  taskGroup.eventType === TRAININGS_GAME.match ||
                  isMatchEvent ||
                  isTrainingEvent
                    ? 'none'
                    : 'block',
              }}
              value={TRAININGS_GAME.general}
            />
          </Tabs>
        </AppBar>
        <TabPanel value={activeTabName} index={TRAININGS_GAME.training}>
          {taskGroup && playersList && (
            <AddEditTrainingTaskGroup
              taskGroup={taskGroup}
              playersList={playersList}
              handlePlayerChange={handlePlayerChange}
              handleInput={handleInput}
              handleCreate={handleCreate}
              handleUpdate={handleUpdate}
              isEditMode={!!selectedTaskGroup}
              dateFormat={dateFormat}
              questions={questions}
              setQuestions={setQuestions}
              handleQuestion={handleQuestion}
              addNewQuestion={addNewQuestion}
              setTaskGroup={setTaskGroup}
              handleCheckboxSelectAllPlayers={handleCheckboxSelectAllPlayers}
              selectAllPlayers={selectAllPlayers}
              eventId={eventId}
            />
          )}
        </TabPanel>
        <TabPanel value={activeTabName} index={TRAININGS_GAME.match}>
          {taskGroup && playersList && (
            <AddEditMatchTaskGroup
              taskGroup={taskGroup}
              playersList={playersList}
              handleEventChange={handleEventChange}
              handlePlayerChange={handlePlayerChange}
              handleInput={handleInput}
              handleCreate={handleCreate}
              handleUpdate={handleUpdate}
              isEditMode={!!selectedTaskGroup}
              dateFormat={dateFormat}
              questions={questions}
              setQuestions={setQuestions}
              handleQuestion={handleQuestion}
              addNewQuestion={addNewQuestion}
              setTaskGroup={setTaskGroup}
              handleCheckboxSelectAllPlayers={handleCheckboxSelectAllPlayers}
              selectAllPlayers={selectAllPlayers}
              eventId={eventId}
            />
          )}
        </TabPanel>
        <TabPanel value={activeTabName} index={TRAININGS_GAME.general}>
          {taskGroup && playersList && (
            <AddEditGeneralTaskGroup
              taskGroup={taskGroup}
              playersList={playersList}
              handleEventChange={handleEventChange}
              handlePlayerChange={handlePlayerChange}
              handleInput={handleInput}
              handleCreate={handleCreate}
              handleUpdate={handleUpdate}
              isEditMode={!!selectedTaskGroup}
              dateFormat={dateFormat}
              questions={questions}
              setQuestions={setQuestions}
              handleQuestion={handleQuestion}
              addNewQuestion={addNewQuestion}
              setTaskGroup={setTaskGroup}
              handleCheckboxSelectAllPlayers={handleCheckboxSelectAllPlayers}
              selectAllPlayers={selectAllPlayers}
              handleTaskSeriesCheckBox={handleTaskSeriesCheckBox}
              taskSeries={taskSeries}
              handleSeriesChange={setTaskSeries}
            />
          )}
        </TabPanel>
      </DialogContent>
    </Dialog>
  )
}
AddTaskGroupDialog.defaultProps = {
  selectedTaskGroup: {},
  isTrainingEvent: false,
  isMatchEvent: false,
  eventId: 0,
  onSuccess: () => {},
}
AddTaskGroupDialog.propTypes = {
  team: PropTypes.shape().isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  selectedTaskGroup: PropTypes.shape(),
  dateFormat: PropTypes.string.isRequired,
  players: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isMatchEvent: PropTypes.bool,
  isTrainingEvent: PropTypes.bool,
  eventId: PropTypes.number,
}
export default compose(
  withRouter,
  connect(({ team, auth, players }) => ({
    team,
    dateFormat: auth.user.datetime_format,
    players: players.items,
  }))
)(AddTaskGroupDialog)
